import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import Iconfont from "@utils/Iconfont";
import { IMAGE_TYPE, BATCH_IMAGES_TYPE, RESOURCE_TYPE } from "@utils/CONST";
import API from "@api/api";
import { workflowOfSendTask } from "@utils/workflowOfBuildTaskV2";

const PicModalRightButton = (props) => {
    const { item, isSelectPage, reEditClick, regenerateByTaskId, onCancel } = props;
    const navigate = useNavigate();
    const [taskId, setTaskId] = useState();
    const [imageId, setImageId] = useState();
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        if (!item) return;
        setTaskId(item?.taskId.split("_")[0]);
        setImageId(item?.results?.[0]?.id);
    }, [item]);

    useEffect(() => {
        const fetchImageUrl = async () => {
            if (!taskId || !imageId) return;
            try {
                const res = await API.batchCommonDownload({ taskId, imageId });
                if (res?.code != 0) throw new Error(res?.message);
                setImageUrl(res.data);
            } catch (error) {
                console.error("Failed to fetch image:", error);
            }
        };
        fetchImageUrl();
    }, [taskId, imageId]);

    const handleClick = async (jumpTotype, targetType = "inputImage", extraState) => {
        const noWaterRes = await API.batchCommonDownload({ taskId, imageId });
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message);
        const image = noWaterRes.data;
        const res = await workflowOfSendTask(jumpTotype, image, targetType, extraState);
        if (!res) return;
        const { pathname, options } = res;
        navigate(pathname, options);
    };

    const extractionClick = () => {
        window.open(imageUrl ? `/home/image_extraction?url=${encodeURIComponent(imageUrl)}` : `/home/image_extraction`, "_blank");
    };

    const resizeClick = () => {
        navigate(imageUrl ? `/home/aiEdit?menuKey=imageResize&url=${encodeURIComponent(imageUrl)}` : `/home/aiEdit?menuKey=imageResize`);
    };

    const isAiEdit = useMemo(() => {
        if (!item) return false;
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_FINER ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX;
    }, [item]);

    if (!item || isAiEdit || item?.orgData) {
        return null;
    }

    if (item?.projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
        const smartDetailButtons = []
        if (!isSelectPage &&
            item?.projectType != BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH &&
            item?.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
            smartDetailButtons.push({
                label: "重新编辑",
                icon: "icon-rebuildOutlined",
                onClick: () => reEditClick(item?.projectId, item?.skuId, item?.taskId),
            })
        }
        if (item?.status === 'succeeded') {
            smartDetailButtons.push({
                label: "编辑图片",
                icon: "icon-Material-EditOutlined",
                onClick: () => props.onOpenMaterialEdit?.(item),
            })
        }
        if (!smartDetailButtons.length) return null
        return (
            <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
                <div className={styles.group}>
                    <div className={styles.groupTitle}>再次操作</div>
                    {smartDetailButtons.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    const modifyImageGroup = [];
    const generateVideoGroup = [];
    const aiEditGroup = [];
    const reOperateGroup = [];
    let creativeImageButton = null;

    const isImageToVideoBatch = item?.projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH;
    if (isImageToVideoBatch) {
        if (!isSelectPage) {
            reOperateGroup.push({
                label: "重新编辑",
                icon: "icon-rebuildOutlined",
                onClick: () => reEditClick(item?.projectId, item?.skuId, item?.taskId),
            });
            reOperateGroup.push({
                label: "再次生成",
                icon: "icon-generateOutlined",
                onClick: () => {
                    regenerateByTaskId(item?.taskId);
                    onCancel && onCancel();
                },
            });
        }

        return (
            <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
                {reOperateGroup.length > 0 && (
                    <div className={styles.group}>
                        <div className={styles.groupTitle}>再次操作</div>
                        {reOperateGroup.map((btn, idx) => (
                            <div key={idx} className={styles.btn} onClick={btn.onClick}>
                                <Iconfont type={btn.icon} className={styles.Icon} />
                                {btn.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    const showTryOnLikeActions =
        item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH;

    const showChangeModel =
        item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH;

    if (showChangeModel) {
        modifyImageGroup.push({ label: "换模特", icon: "icon-aiModelOutlined", onClick: () => handleClick(IMAGE_TYPE.MODEL) });
    }

    const showChangeBackground =
        item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH;

    if (showChangeBackground) {
        modifyImageGroup.push({ label: "换背景", icon: "icon-aibgOutlined", onClick: () => handleClick(IMAGE_TYPE.BACKGROUND) });
    }

    if (showTryOnLikeActions) {
        modifyImageGroup.push({ label: "换姿势", icon: "icon-poseFantasyOutlined", onClick: () => handleClick(IMAGE_TYPE.POSE_TRYON) });
    }

    const showChangeClothes =
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH;

    if (showChangeClothes) {
        modifyImageGroup.push({
            label: (item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH || item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) ? "换衣服" : "AI试衣",
            icon: "icon-outfitSmallOutlined",
            onClick: () => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL),
        });
    }

    if (showTryOnLikeActions) {
        modifyImageGroup.push({ label: "换鞋子", icon: "icon-shoesOutlined", onClick: () => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES) });
        modifyImageGroup.push({ label: "换眼镜", icon: "icon-glassesOutlined", onClick: () => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON) });
        modifyImageGroup.push({ label: "换项链", icon: "icon-necklaceOutlined", onClick: () => handleClick(IMAGE_TYPE.NECKLACE_TRYON, RESOURCE_TYPE.NECKLACE_TRYON, { silentSelect: true }) });
        modifyImageGroup.push({ label: "同版型试衣", icon: "icon-sametryOutlined", onClick: () => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON) });
    }

    const showCreativeImageGen =
        item.imageType !== IMAGE_TYPE.MODEL_VIDEO &&
        item.imageType !== IMAGE_TYPE.IMAGE_TO_VIDEO &&
        item.projectType !== BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH;

    if (showCreativeImageGen) {
        creativeImageButton = { label: "AI创意生图", icon: "icon-genimageOutlined", onClick: () => handleClick(IMAGE_TYPE.CREATIVE_IMAGE_GEN) };
    }

    const showFusionWear =
        item.projectType !== BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH &&
        item.projectType !== BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH;

    if (showFusionWear) {
        modifyImageGroup.push({ label: "换穿搭", icon: "icon-outfitSmallOutlined", onClick: () => handleClick(IMAGE_TYPE.FUSION_WEAR, RESOURCE_TYPE.FUSIONWEAR_MODEL) });
    }

    if (item.projectType !== BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH &&
        item.projectType !== BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        modifyImageGroup.push({ label: "去种草", icon: "icon-sProductshowcaseOutlined", onClick: () => handleClick(IMAGE_TYPE.GRASS_PLANT) });
    }

    if (item.projectType !== BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
        modifyImageGroup.push({ label: "服饰换色", icon: "icon-recolorOutlined", onClick: () => handleClick(IMAGE_TYPE.CLOTH_RECOLOR) });
    }

    if (item.projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH) {
        modifyImageGroup.push({ label: "商品换背", icon: "icon-commidityOutlined", onClick: () => handleClick(IMAGE_TYPE.COMMODITY) });
    }

    const showCommodityRecolor =
        item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH;

    if (showCommodityRecolor) {
        modifyImageGroup.push({ label: "商品换色", icon: "icon-recolorOutlined", onClick: () => handleClick(IMAGE_TYPE.COMMODITYRECOLOR) });
    }

    generateVideoGroup.push({ label: "图生视频", icon: "icon-tryonVideoOutlined", onClick: () => handleClick(IMAGE_TYPE.IMAGE_TO_VIDEO) });

    if (showTryOnLikeActions) {
        generateVideoGroup.push({ label: "动作模仿", icon: "icon-tryonVideoOutlined", onClick: () => handleClick(IMAGE_TYPE.MODEL_VIDEO) });
    }

    aiEditGroup.push(
        { label: "抠图", icon: "icon-mattingOutlined", onClick: extractionClick },
        { label: "改尺寸", icon: "icon-picResizeOutlined", onClick: resizeClick },
        { label: "AI超清", icon: "icon-hasHDOutlined", onClick: () => navigate("/home/aiEdit", { state: { menuKey: "imageFiner", picUrl: imageUrl } }) },
        { label: "修光影", icon: "icon-lightIconOutlined", onClick: () => navigate("/home/aiEdit", { state: { menuKey: "filllight", picUrl: imageUrl } }) },
        { label: "修手", icon: "icon-handRepairOutlined", onClick: () => navigate("/home/aiEdit", { state: { menuKey: "handRepair", picUrl: imageUrl } }) },
        { label: "去杂物", icon: "icon-magicRemoveOutlined", onClick: () => navigate("/home/aiEdit", { state: { menuKey: "magicErase", picUrl: imageUrl } }) },
    );

    if (item.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
        aiEditGroup.push({ label: "去水印", icon: "icon-removeWatermark", onClick: () => handleClick(IMAGE_TYPE.WATERMARK_REMOVE) });
    }

    if (!isSelectPage &&
        item?.projectType != BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH &&
        item?.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
        reOperateGroup.push({
            label: "重新编辑",
            icon: "icon-rebuildOutlined",
            onClick: () => reEditClick(item?.projectId, item?.skuId, item?.taskId),
        });
    }

    if (!isSelectPage ) {
        reOperateGroup.push({
            label: "再次生成",
            icon: "icon-generateOutlined",
            onClick: () => {
                regenerateByTaskId(item?.taskId);
                onCancel && onCancel();
            },
        });
    }

    return (
        <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
            {creativeImageButton && (
                <div className={styles.group}>
                    <div className={styles.btn} onClick={creativeImageButton.onClick}>
                        <Iconfont type={creativeImageButton.icon} className={styles.Icon} />
                        {creativeImageButton.label}
                    </div>
                </div>
            )}

            {modifyImageGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>修改图片</div>
                    {modifyImageGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {generateVideoGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>生成视频</div>
                    {generateVideoGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {aiEditGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>AI 编辑</div>
                    {aiEditGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {reOperateGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>再次操作</div>
                    {reOperateGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PicModalRightButton;
